import { render, staticRenderFns } from "./PoliticaComercialManage.vue?vue&type=template&id=304cffbc&scoped=true"
import script from "./PoliticaComercialManage.vue?vue&type=script&lang=js"
export * from "./PoliticaComercialManage.vue?vue&type=script&lang=js"
import style0 from "./PoliticaComercialManage.vue?vue&type=style&index=0&id=304cffbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304cffbc",
  null
  
)

export default component.exports